const loadItems = (button) => {
  const nextUrlInput = document.querySelector('[data-next-url]');
  const totalPagesInput = document.querySelector('[data-total-pages]');
  const currentPageInput = document.querySelector('[data-current-page]');
  if (!nextUrlInput || !totalPagesInput || !currentPageInput) return;

  const totalPages = parseInt(totalPagesInput.value, 10);
  let currentPage = parseInt(currentPageInput.value, 10) + 1;
  const currentPageScroll = currentPage + 1;

  const nextUrl = nextUrlInput.value.replace(/page=[0-9]+/, 'page=' + currentPage);
  const nextUrlScroll = nextUrlInput.value.replace(/page=[0-9]+/, 'page=' + currentPageScroll);
  currentPageInput.value = currentPage;

  button.setAttribute('disabled', '');
  button.classList.add('loading');

  fetch(nextUrl, { method: 'GET', headers: { Accept: 'text/html' } })
    .then((response) => response.text())
    .then((responseHTML) => {
      const parser = new DOMParser();
      const doc = parser.parseFromString(responseHTML, 'text/html');
      const grid = document.querySelector('.load-more-grid');
      const newGrid = doc.querySelector('.load-more-grid');
      if (grid && newGrid) {
        grid.insertAdjacentHTML('beforeend', newGrid.innerHTML);
      }
      if (typeof colorSwatches === 'function') {
        colorSwatches();
      } else {
        document.dispatchEvent(new CustomEvent('shopify:section:load'));
      }
    })
    .catch((error) => console.error('Load more failed:', error))
    .finally(() => {
      if (currentPage <= totalPages) {
        const scrollData = document.querySelector('.infinite-scroll__data');
        if (scrollData && currentPage != totalPages) {
          const scrollNextUrlInput = scrollData.querySelector('input[data-next-url]');
          const scrollCurrentPageInput = scrollData.querySelector('input[data-current-page]');
          scrollNextUrlInput.dataset.nextUrl = nextUrlScroll;
          scrollNextUrlInput.value = nextUrlScroll;
          scrollCurrentPageInput.dataset.currentPage = currentPage;
          scrollCurrentPageInput.value = currentPage;
          checkVisibility();
        }
        button.removeAttribute('disabled');
        button.classList.remove('loading');
        if (currentPage == totalPages) {
          button.remove();
        }
      }
    });
};

const checkVisibility = () => {
  const spinnerList = document.querySelectorAll('.js-infinite-scroll');
  spinnerList.forEach((spinner) => {
    const sectionObserver = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          loadItems(spinner);
        }
      });
    });

    sectionObserver.observe(spinner);
  });
};

function loadMore() {
  document.querySelectorAll('.js-load-more').forEach((button) => {
    button.onclick = () => {
      loadItems(button);
    };
  });

  checkVisibility();
}

(function () {
  loadMore();
})();
